import {
  Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { ListOpenQuoteWrapper } from '@app/pages/quote/open-quote/list-open-quote/list-open-quote-wrapper.component';

@Component({
  selector: 'app-list-open-quote-mobile',
  templateUrl: './list-open-quote-mobile.component.html',
  styleUrls: ['./list-open-quote-mobile.component.scss'],
})
export class ListOpenQuoteMobileComponent extends ListOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
